import { apiService } from '@/utils/api';
import type { DeviceMessageItem } from '@/types/api';

export async function getHistoryError(deviceId: string): Promise<DeviceMessageItem[]> {
  return apiService.get<DeviceMessageItem[]>(`/api/v1/iot-shadow/device/${deviceId}/historyError`);
}

export async function resetError(deviceId: string, errorIndex: number): Promise<DeviceMessageItem[]> {
  return apiService.post<DeviceMessageItem[]>(`/api/v1/iot-shadow/device/${deviceId}/resetError`, {
    error_index: errorIndex,
  });
}